<ng-container *transloco="let t">
  <div
    id="partner-disclosure-dialog-container"
    class="bg-white w-full rounded-2xl shadow-xl flex flex-col overflow-hidden"
    style="max-height: calc(100dvh - 2rem - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px))"
  >
    <header id="partner-disclosure-dialog-header" class="flex items-center justify-between gap-6 px-6 py-4 shrink-0">
      @if (config.logo) {
        <img [src]="config.logo" [alt]="config.name" class="max-h-[72px] w-auto" />
        <h2 id="partner-disclosure-dialog-title" class="sr-only">{{ t('modalsPartnerDisclosureTitle') }}</h2>
      } @else {
        <h2 id="partner-disclosure-dialog-title" class="text-xl font-dm font-medium text-ld-neutral leading-7 m-0">
          {{ t('modalsPartnerDisclosureTitle') }}
        </h2>
      }
      <button
        id="partner-disclosure-dialog-close-btn"
        type="button"
        class="flex items-center justify-center w-8 h-8 rounded-full bg-transparent border-0 cursor-pointer hover:bg-ld-neutral-100 transition-colors focus-visible:outline-2 focus-visible:outline-ld-primary focus-visible:outline-offset-2"
        [attr.aria-label]="t('commonAriaClose')"
        (click)="onCancel()"
      >
        <span class="text-ld-neutral-500 text-base leading-none" aria-hidden="true">✕</span>
      </button>
    </header>

    <div id="partner-disclosure-dialog-content" class="flex-1 overflow-y-auto p-6 text-left">
      <p id="partner-disclosure-dialog-text" class="text-ld-neutral-700 font-dm text-base leading-6 mb-4">
        {{ t(config.translationKeyPrefix + 'DisclosureText') }}
      </p>

      <p id="partner-disclosure-dialog-redirect" class="text-ld-neutral-700 font-dm text-base leading-6 mb-4">
        {{ t('modalsPartnerDisclosureClickText') }}
        <strong>{{ t(config.confirmButtonKey) }}</strong>
        {{ t('modalsPartnerDisclosureRedirectText', { partnerName: config.name }) }}
      </p>

      @if (config.disclaimerFootnoteKey) {
        <p class="text-ld-neutral-500 font-dm text-sm leading-5 mb-4">
          {{ t(config.disclaimerFootnoteKey) }}
        </p>
      }

      <p id="partner-disclosure-dialog-disclaimer" class="text-ld-neutral-500 font-dm text-sm leading-5">
        @if (config.disclaimerTextBeforeKey) {
          {{ t(config.disclaimerTextBeforeKey) }}
          @if (config.privacyPolicyUrl) {
            <a
              id="partner-disclosure-dialog-privacy-link"
              [href]="config.privacyPolicyUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="text-ld-link hover:text-ld-link-hover underline"
              (click)="$event.stopPropagation()"
            >
              {{ t(config.privacyLinkKey ?? 'commonLinksPrivacyPolicy') }}
            </a>
          }
          @if (config.termsUrl) {
            {{ t('commonAnd') }}
            <a
              id="partner-disclosure-dialog-terms-link"
              [href]="config.termsUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="text-ld-link hover:text-ld-link-hover underline"
              (click)="$event.stopPropagation()"
            >
              {{ t(config.termsLinkKey ?? 'commonLinksTermsOfUse') }}
            </a>
          }
          @if (config.disclaimerTextAfterKey) {
            {{ t(config.disclaimerTextAfterKey) }}
          }
        } @else {
          {{ t(config.translationKeyPrefix + 'DisclaimerText') }}
          @if (config.privacyPolicyUrl) {
            <a
              id="partner-disclosure-dialog-privacy-link"
              [href]="config.privacyPolicyUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="text-ld-link hover:text-ld-link-hover underline"
              (click)="$event.stopPropagation()"
            >
              {{ t('commonLinksPrivacyPolicy') }}
            </a>
          }
          @if (config.termsUrl) {
            <span>{{ t('commonAnd') }}</span>
            <a
              id="partner-disclosure-dialog-terms-link"
              [href]="config.termsUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="text-ld-link hover:text-ld-link-hover underline"
              (click)="$event.stopPropagation()"
            >
              {{ t('commonLinksTermsOfUse') }}
            </a>
          }
        }
      </p>
    </div>

    <footer id="partner-disclosure-dialog-footer" class="px-6 py-6 shrink-0">
      <div class="flex flex-col gap-3">
        <button
          id="partner-disclosure-dialog-confirm"
          type="button"
          class="btn-primary-ld-purple w-full !order-1"
          (click)="onConfirm()"
        >
          {{ t(config.confirmButtonKey) }}
        </button>
        <button
          id="partner-disclosure-dialog-cancel"
          type="button"
          class="btn-outline-ld-purple w-full !order-2"
          (click)="onCancel()"
        >
          {{ t('commonButtonsCancel') }}
        </button>
      </div>
    </footer>
  </div>
</ng-container>
